export const Logo = () => {
  return (
    <a href="/" className="text-lg font-bold text-black/70 leading-none">
      DXRating.net
    </a>
  )
}